<template>
  <div class="register">
    <div class="header">
      <a
        href="http://mp.weixin.qq.com/s?__biz=Mzg2ODIxNjAxNQ==&mid=100000002&idx=1&sn=ba49583c85b8e69d032b4d507e714d41&chksm=4eaefca279d975b4e7a5a1ade4ff65dbb2e8972fc8eefa6ab45ffbfa6b070978373eb947e31c#rd"
      >
        <img src="../assets/head.jpeg">
      </a>
    </div>

    <div class="body">
      <div>
        <van-field
          v-model="tel"
          required
          label="手机号"
          placeholder="请输入手机号"
          v-on:click.stop="stopCheck()"
          error-message
        />
        <van-field
          v-model="sms"
          required
          center
          clearable
          label="短信验证码"
          v-on:click.stop="stopCheck()"
          placeholder="请输入短信验证码"
        >
          <van-button
            v-show="isshow"
            slot="button"
            size="small"
            type="primary"
            @click="sendSms()"
          >发送验证码</van-button>
          <van-text v-show="!isshow" slot="button" size="small" type="text">重新发送{{time}}</van-text>
        </van-field>
      </div>
      <div class="badge">
        <div style="width: 100px">
          <p class="tip">上传胸卡图片</p>
          <p class="tip3">二次上传自动替换</p>
        </div>

        <div class="tupian">
          <van-uploader :after-read="onRead"/>
          <div v-show="imgFlg" class="up-img">
            <img :src="work_card_photo">
            <!-- <p class="delete">
                <!-- <span><van-icon name="cross" size="20" @click-icon='deleteImg()' /></span> 
                <!-- <img src="http://wsl-cdn.mymeeting.com.cn/1560686095233_del.png"  class="delImg" /> 
                <van-button  
                  icon="cross" 
                  size="small" 
                  type="primary" 
                  slot="button" 
                  @click="deleteImg()" 
                  class="button_del">
            <!-- <img src="http://wsl-cdn.mymeeting.com.cn/1560686095233_del.png" class="delImg"  @click.native="deleteImg()">-->
            <!-- <span @click="deleteImg()"><i class="el-icon-document-delete" style="font-size: 20px;"></i></span> 
                </van-button>
                  <van-button
                  v-show="isshow"
                  slot="button"
                  size="small"
                  type="primary"
                  @click="deleteImg()"
                >删除</van-button>
            </p>-->
          </div>
        </div>

        <p class="tip2">请上传带有您姓名、照片的工牌进行身份验证，项目组会进行审核</p>
      </div>

      <div class="apply">
        <van-button type="info" class="apply_title" @click="submit()">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
import { apiURL } from "@/config/service.js";
import Cookies from "js-cookie";
//七牛上传插件
import * as qiniu from "qiniu-js";

export default {
  name: "Register",
  data() {
    return {
      tel: "",
      sms: "",
      isshow: true,
      time: 20,
      inter: "",
      work_card_photo: "",
      imgFlg: false
    };
  },

  methods: {
    // 阻止点击输入引起checkbox 选中变好
    stopCheck() {
      return false;
    },
    // 提交
    submit() {
      // 用户注册
      // 发送短信验证
      let data = {};
      data.tel = this.tel;
      data.sms = this.sms;
      data.work_card_photo = this.work_card_photo;
      if (this.work_card_photo.length == 0) {
        this.customAlert("请先上传胸卡照片");
        return;
      }
      data.openid = Cookies.get("openid");
      Http.post(api.register, data).then(response => {
        if (response.code == 1) {
          // 跳转到个人中心页
          this.customAlert("注册成功");
          Cookies.set("uid", response.uid, { expires: 7 });
          this.$router.push({ name: "User" });
        } else {
          // 发送失败
          this.customAlert(response.msg);
          return false;
        }
      });
    },
    // 弹框
    customAlert(msg) {
      this.$dialog.alert({
        message: msg
      })
    },
    // 发送验证码
    sendSms() {
      // 判断是否是手机号
      // 增加重复点击的判断
      this.tel = this.tel.trim();
      const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.tel)) {
        this.customAlert("请输入准确的手机号");
        return;
      }
      // 发送短信验证
      let data = {};
      data.tel = this.tel;
      Http.post(api.sendSms, data).then(response => {
        if (response.code == 1) {
          // 发送短信验证码
          this.isshow = false;
          this.inter = setInterval(() => {
            this.time--;
            if (this.time <= 0) {
              this.time = 30;
              this.isshow = true;
              clearInterval(this.inter);
            }
          }, 1000);
        } else {
          // 发送失败
          this.customAlert(response.msg);
          return false;
        }
      });
    },
    // 删除图片
    deleteImg() {
      console.log("kkkk");
      this.work_card_photo = "";
      return;
    },
    // 上传胸牌图片
    onRead(fileObject) {
      //  this.customAlert('稍后配置完善')
      // return
      const data = {};
      Http.post(api.qiniuToken, data).then(response => {
        const uptoken = response.token;
        if (!uptoken) {
          this.customAlert("上传失败");
          return;
        }
        var file = fileObject.file; //Blob 对象，上传的文件
        var key = new Date().getTime() + "_" + fileObject.file.name; // 上传后文件资源名以设置的 key 为主，如果 key 为 null 或者 undefined，则文件资源名会以 hash 值作为资源名。

        let config = {
          useCdnDomain: true, //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
          region: qiniu.region.z1 // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
        };

        let putExtra = {
          fname: "", //文件原文件名
          params: {}, //用来放置自定义变量
          mimeType: null //用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
        };
        var observable = qiniu.upload(file, key, uptoken, putExtra, config);
        observable.subscribe({
          next: result => {
            // 主要用来展示进度
            console.log(result);
          },
          error: errResult => {
            // 失败报错信息
            this.customAlert("上传失败");
            console.log(errResult);
          },
          complete: result => {
            // 接收成功后返回的信息
            console.log("上传成功");
            console.log(result);
            this.imgFlg = true;
            this.work_card_photo =
              "http://wsl-cdn.mymeeting.com.cn/" + result.key;
          }
        });
      });
      return;
    },
    isRegister() {
      let data = {};
      data.openid = Cookies.get("openid");
      Http.post(api.getUserInfo, data).then(response => {
        if (response.code == 1) {
          if (response.data.id != 0) {
            Cookies.set("uid", response.data.id);
          }
          this.$dialog
            .alert({
              message: "您已成功加入项目，请尽快完成调研问卷。"
            })
            .then(() => {
              this.$router.push({ name: "ResearchList" });
            });
          return;
        } else {
          // 发送失败
          // this.customAlert('获取失败')
          return false;
        }
      });
    }
  },
  mounted: function() {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    // 判断用户是否注册
    this.isRegister()
  }
};
</script>

<style lang="less">
.register {
  .header {
    img {
      width: 100%;
      display: block;
    }
  }
  .body {
    margin-top: 1rem;
    .badge {
      margin-left: 8px;
      margin-top: 24px;
      margin-bottom: 24px;
      .tip {
        font-size: 14px;
      }
      .tip3 {
        font-size: 12px;
        color: #655d5d;
      }
      .tip2 {
        font-size: 12px;
        color: red;
        position: relative;
        top: -90px;
      }
      .tip::before {
        color: #f44;
        font-size: 14px;
        content: "*";
      }
      .tupian {
        position: relative;
        top: -100px;
        left: 110px;
      }
      .up-img {
        display: inline-block;
        position: relative;
        top: 20px;
        .delImg {
          position: relative;
          width: 20px;
          height: 20px;
          margin-left: 0px;
          top: -10px;
          cursor: pointer;
          z-index: 989;
        }
        .button_del {
          //  background: #fff;
          display: inline-block;
          border: 0;
          padding: 0;
          // height: 20px;
          // min-width: 20px;
          min-width: 30px;
          height: 30px;
          z-index: 289;
          cursor: pointer;
        }
      }
      .delete {
        display: inline-block;
        margin-block-start: 0em;
        margin-block-end: 0em;
        position: relative;
        top: -60px;
        cursor: pointer;
      }
      img {
        width: 86px;
        vertical-align: bottom;
        height: 86px;
        margin-left: 50px;
      }
    }
    .apply {
      text-align: center;
      position: relative;
      top: -90px;
      &_title {
        font-size: 18px;
        width: 30%;
        color: #007bf7;
        background-color: #fff;
        border-radius: 1rem;
        margin-bottom: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue